// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 261 ? "rag-service" : chunkId) + "." + {"159":"a7f78360","261":"c1891230"}[chunkId] + ".chunk.js";
};